const getRidesCollectionPath = (groupId) => `apps/dispatch/groups/${groupId}/rides`;

export default getRidesCollectionPath;
